import { render, staticRenderFns } from "./AddMaterials.vue?vue&type=template&id=4dbd1eee"
import script from "./AddMaterials.vue?vue&type=script&lang=js"
export * from "./AddMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports